import type { DateRange } from 'radix-vue'
import { CalendarDate } from '@internationalized/date'
import { defineStore } from 'pinia'

type DateRangeWithCompare = DateRange & { compare_type?: string }

interface User {
  id: number
  name: string
  // ... otras propiedades del usuario
}

interface CompanyMembership {
  id: number
  company_id: number
  user_id: number
  role: string
  // Add other properties as needed
}

interface SelectedModule {
  name: string
  plan: string
}

interface DataState {
  user: User | null
  company: string | null | number
  isCompanySelectorOpen: boolean
  dateRange: DateRangeWithCompare | null
  tableFilters: any[]
  creditNote: boolean
  companyMemberships: CompanyMembership[]
  selectedModule: SelectedModule | null
}

const today = new CalendarDate(new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate())

export const useDataStore = defineStore('data', {
  state: (): DataState => ({
    user: null,
    company: null,
    isCompanySelectorOpen: false,
    creditNote: false, // Estado inicial
    dateRange: {
      start: today.subtract({ months: 3 }),
      end: today,
      compare_type: 'prev-month',
    },
    tableFilters: [],
    companyMemberships: [],
    selectedModule: {
      name: 'Financiero & Contable',
      plan: 'Enterprise',
    },
  }),

  getters: {
    getCompany: state => state.company,
    getDateRange: state => state.dateRange,
    getTableFilters: (state): any[] => state.tableFilters,
    getCreditNote: state => state.creditNote,
    getCompanyMemberships: state => state.companyMemberships,
    getSelectedModule: state => state.selectedModule,
  },

  actions: {
    setCompany(company: string | null | number) {
      this.company = company
    },

    setUser(user: User) {
      this.user = user
    },

    openCompanySelector() {
      this.isCompanySelectorOpen = true
    },

    closeCompanySelector() {
      this.isCompanySelectorOpen = false
    },

    setDateRange(range: DateRangeWithCompare | null) {
      this.dateRange = range ? { ...range } : null
    },

    setTableFilters(filters: any[]) {
      this.tableFilters = filters
    },

    setCreditNote(value: boolean) {
      this.creditNote = value
    },

    setCompanyMemberships(companyMemberships: CompanyMembership[]) {
      this.companyMemberships = companyMemberships
    },

    setSelectedModule(module: SelectedModule) {
      this.selectedModule = module
    },
  },

  persist: true,
})
